import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
const Spacer = memo(({ className, gap, ...rest }) => {
  const componentClassName = `${useClassNamePrefix()}spacer`;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(
        componentClassName,
        toEnumViewClass(gap),
        className
      ),
      ...rest
    }
  );
});
export {
  Spacer
};
//# sourceMappingURL=Spacer.js.map
